import React, { Fragment } from 'react';

import { Grid, TextField, useMediaQuery } from '@mui/material';
import useTransformStore from '../../useTransformStore';
import ChipInput from '../../../ChipInput/ChipInput';
import { SelectConditional, SelectLogic } from '../Component';

// Icons
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';

function CountIfConditionalIsMet({
  conditionIsMet,
  availablePlaceholders,
  onPlaceholderSelected,
  index,
  isExpanded,
}) {
  {
    console.log(isExpanded);
  }
  return (
    <Fragment>
      <Grid item xs={12} className="item-label">
        Count the values that meet this condition
      </Grid>
      <Grid item xs={12}>
        {conditionIsMet &&
          conditionIsMet.map((c, p) => {
            return isExpanded ? (
              <Grid container spacing={2}>
                {p > 0 && (
                  <Grid item xs={12} sm={6} md={2} lg={2} xl={2}>
                    <SelectLogic
                      value={c.logic}
                      onChange={value =>
                        useTransformStore.getState().setCondition(value, index, p, 'logic', 'conditionIsMet')
                      }
                    />
                  </Grid>
                )}
                <Grid item xs={12} sm={6} md={2} lg={2} xl={2}>
                  <SelectConditional
                    value={c.func}
                    onChange={value =>
                      useTransformStore.getState().setCondition(value, index, p, 'func', 'conditionIsMet')
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6} xl={6} className="input-list-transform">
                  <ChipInput
                    placeholders={availablePlaceholders}
                    onPlaceholderSelected={onPlaceholderSelected}
                    fullWidth
                    onBeforeAdd={chip => {
                      useTransformStore.getState().setCondition(chip, index, p, 'value', 'conditionIsMet');
                      return true;
                    }}
                    placeholder="Insert placeholder, text or integer. "
                    inputValue={c.value}
                    onDelete={indexChip =>
                      useTransformStore.getState().deleteChipCondition(indexChip, index, p, 'conditionIsMet')
                    }
                    onFocus={() => useTransformStore.getState().setFocusCondition(index, p, 'conditionIsMet')}
                  />
                </Grid>
                {p > 0 && (
                  <Grid item xs={1} className="item-icon-delete">
                    <DeleteIcon
                      onClick={() => useTransformStore.getState().deleteCondition(index, p, 'conditionIsMet')}
                    />
                  </Grid>
                )}
              </Grid>
            ) : (
              <Grid container spacing={2}>
                {p > 0 && (
                  <>
                    <Grid item xs={2}>
                      <SelectLogic
                        value={c.logic}
                        onChange={value =>
                          useTransformStore.getState().setCondition(value, index, p, 'logic', 'conditionIsMet')
                        }
                      />
                    </Grid>
                    <Grid item xs={10}></Grid>
                  </>
                )}
                <Grid item xs={6}>
                  <SelectConditional
                    value={c.func}
                    onChange={value =>
                      useTransformStore.getState().setCondition(value, index, p, 'func', 'conditionIsMet')
                    }
                  />
                </Grid>
                <Grid item xs={6}></Grid>
                <Grid item xs={11} className="input-list-transform">
                  <ChipInput
                    placeholders={availablePlaceholders}
                    onPlaceholderSelected={onPlaceholderSelected}
                    fullWidth
                    onBeforeAdd={chip => {
                      useTransformStore.getState().setCondition(chip, index, p, 'value', 'conditionIsMet');
                      return true;
                    }}
                    placeholder="Insert placeholder, text or integer. "
                    inputValue={c.value}
                    onDelete={indexChip =>
                      useTransformStore.getState().deleteChipCondition(indexChip, index, p, 'conditionIsMet')
                    }
                    onFocus={() => useTransformStore.getState().setFocusCondition(index, p, 'conditionIsMet')}
                  />
                </Grid>
                {p > 0 && (
                  <Grid item xs={1} className="item-icon-delete">
                    <DeleteIcon
                      onClick={() => useTransformStore.getState().deleteCondition(index, p, 'conditionIsMet')}
                    />
                  </Grid>
                )}
              </Grid>
            );
          })}
      </Grid>
      <Grid item xs={12} sm={12} md={11} lg={11} xl={11}>
        <div
          className="item-text-add"
          onClick={() => useTransformStore.getState().addCondition(index, 'conditionIsMet')}
        >
          <AddIcon /> Add AND/OR condition
        </div>
      </Grid>
    </Fragment>
  );
}

export default CountIfConditionalIsMet;
